const infoText = ({ functions, typography }) => {
  const { fontWeightRegularLight, size } = typography;
  return {
    fontSize: size.sm,
    fontFamily: fontWeightRegularLight,
  };
};
export default infoText;
